import { useMemo } from "react";
import { AD_LIST } from "../../data/adList";

// typeには "BANNERS" や "RECTANGLE" などの文字列を渡すようにする
export default function AdSquare({ type = "SQUARE" }) {
  
  // 指定されたタイプの広告枠からランダムに1つ選ぶ
  const banner = useMemo(() => {
    const currentGroup = AD_LIST[type]; // ここで動的にどのバナー枠かを指定
    if (!currentGroup || currentGroup.length === 0) return null;
    
    return currentGroup[Math.floor(Math.random() * currentGroup.length)];
  }, [type]);

  if (!banner) return null;

  return (
    <div className="max-w-[300px] h-[300px] bg-base-50 border border-dashed border-base-200 flex items-center justify-center text-base-500 text-xs rounded">
      <a href={banner.url} rel="noopener noreferrer">
        <img src={banner.src} alt={banner.alt} className="w-full h-full object-cover" />
      </a>
    </div>
    // <div className="w-[300px] h-[300px] bg-base-50 border border-dashed border-base-200 flex items-center justify-center text-base-500 text-xs rounded">
    //   広告（300×300）
    // </div>
  );
}